/** True when we expect touch-first input without a precision pointing device (mouse). */
function isLikelyTouchOnlyDevice(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(pointer: fine)").matches) return false;
  if (window.matchMedia("(pointer: coarse)").matches) return true;
  const touch = navigator.maxTouchPoints > 0;
  const noHover = window.matchMedia("(hover: none)").matches;
  const narrow = window.matchMedia("(max-width: 900px)").matches;
  return touch && noHover && narrow;
}

function waitForMobileContinue(warnEl: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    const btn = warnEl.querySelector<HTMLButtonElement>("[data-mobile-continue]");
    if (!btn) {
      resolve();
      return;
    }
    const onClick = () => {
      btn.removeEventListener("click", onClick);
      warnEl.setAttribute("hidden", "");
      resolve();
    };
    btn.addEventListener("click", onClick);
  });
}

async function gate(): Promise<void> {
  if (new URLSearchParams(window.location.search).get("embed") === "1") {
    await import("./main");
    return;
  }
  if (!isLikelyTouchOnlyDevice()) {
    await import("./main");
    return;
  }

  const loading = document.getElementById("game-loading");
  const warn = document.getElementById("mobile-desktop-warning");
  if (!warn) {
    await import("./main");
    return;
  }

  if (loading) loading.setAttribute("hidden", "");
  warn.removeAttribute("hidden");
  warn.setAttribute("aria-modal", "true");

  await waitForMobileContinue(warn);

  if (loading) loading.removeAttribute("hidden");
  await import("./main");
}

void gate();
